import React, { useState, useEffect } from 'react'
import './Projects.css'
import { Fade } from 'react-reveal'
import ApolloClient, { gql } from 'apollo-boost'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { featured_projects } from '../../data/featured_projects.json'
import Project from '../project/Project'
import Section from '../section/Section'
import FeaturedProject from '../featuredProject/FeaturedProject'

const useStyles = makeStyles((theme) => ({
  moreProjects: {
    '&': {
      margin: '20px auto',
      backgroundColor: '#f9dd3c',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#c6ad21',
        boxShadow: 'none',
      },
    },
    '& > *': {
      color: 'black',
      padding: 4,
      fontSize: '15px',
      fontWeight: '600',
    },
  },
}))

const client = new ApolloClient({
  uri: 'https://api.github.com/graphql',
  request: (operation) => {
    operation.setContext({
      headers: {
        authorization: `Bearer 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`,
      },
    })
  },
})

const queryInfo = {
  owner: 'jretondo',
  repositories: [
    'osecac-backend-2',
    'club-limpieza-frontend-react-admin',
    'club-limpieza-back-ts',
  ],
}

const query = gql`
  fragment repoProperties on Repository {
    name 
    description
    url
    id
    diskUsage
    languages(first: 2, orderBy: { field: SIZE, direction: DESC }) {
      nodes {
        name
        color
      }
    }
  }

  {
    user(login: "${queryInfo.owner}") {
      ${queryInfo.repositories
    .map(
      (repo, index) => `repo${index + 1}: repository(name: "${repo}") {
        ...repoProperties
      }`
    )
    .join('\n')}
    }
  }`

const Projects = ({
  language
}) => {
  const [githubProjects, setGithubProjects] = useState([])
  const [loadProjectsError, setLoadProjectsError] = useState(null)

  const classes = useStyles()

  useEffect(() => {
    getProjects()
  }, [])

  const getProjects = async () => {
    try {
      const queryResult = await client.query({
        query,
      })
      setGithubProjects(queryResult.data.user)
      setLoadProjectsError(false)
    } catch (error) {
      console.log(error)
      setLoadProjectsError(true)
    }
  }

  if (loadProjectsError === false) {
    return (
      <Section title={language === 0 ? "Proyectos" : "Projects"}>
        <div className="projects-content">
          <ul className="projects-list">
            {language === 0 ? <h3>Terminados</h3> : <h3>Finished</h3>}
            {featured_projects.map((featuredProject) => {
              return (
                <li key={`featured-project-${featuredProject.id}`}>
                  <Fade bottom duration={1000} distance="20px">
                    <FeaturedProject
                      name={featuredProject.name}
                      link={featuredProject.link}
                      description={featuredProject.description}
                      colour={featuredProject.colour}
                      languages={featuredProject.languages}
                    />
                  </Fade>
                </li>
              )
            })}
            {language === 0 ? <h3>En proceso</h3> : <h3>In progress</h3>}
            {Object.keys(githubProjects).map((repo) => {
              if (githubProjects[repo].name) {
                return (
                  <li key={githubProjects[repo].name}>
                    <Fade bottom duration={1000} distance="20px">
                      <Project project={githubProjects[repo]} type={'github'} />
                    </Fade>
                  </li>
                )
              } else {
                return null
              }
            })}
          </ul>
          <Fade bottom duration={1000} distance="20px">
            <div className="more-projects-wrapper">
              <a
                className="project-link"
                href={'https://github.com/jretondo'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  className={classes.moreProjects}
                  type="button"
                  variant="contained"
                >
                  {language === 0 ? "más proyectos" : "more projects"}
                </Button>
              </a>
            </div>
          </Fade>
        </div>
      </Section>
    )
  } else {
    return null
  }
}

export default Projects
